import { motion } from 'framer-motion';

export default function FeaturesSection() {
  const features = [
    {
      badge: null,
      icon: 'ri-database-2-line',
      title: '기업회원 전용 인재 DB',
      description: '검증된 인재 정보를 실시간으로 확인하고 직접 컨택하세요',
      size: 'large',
    },
    {
      badge: { text: '무료', color: 'bg-neon-green' },
      icon: 'ri-user-heart-line',
      title: '개인회원 완전 무료',
      description: '모든 공고 열람 및 지원 무료',
      size: 'normal',
    },
    {
      badge: { text: '프리미엄', color: 'bg-neon-pink' },
      icon: 'ri-shield-check-line',
      title: '안심 채팅 시스템',
      description: '연락처 비공개로 안전하게 소통',
      size: 'normal',
    },
  ];

  return (
    <section className="relative py-32 bg-dark-deep">
      <div className="container mx-auto px-20">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-6xl font-black text-white mb-4">온니잡만의 특별함</h2>
          <p className="text-xl text-gray-400">업계 특화 기능으로 더 빠르고 안전하게</p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid grid-cols-12 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`${
                feature.size === 'large' ? 'col-span-6' : 'col-span-3'
              } relative group cursor-pointer`}
            >
              <div className="h-full bg-white/5 backdrop-blur-glass rounded-3xl p-10 border border-white/10 hover:border-neon-purple/50 transition-all duration-300 hover:shadow-neon-purple">
                {/* Badge */}
                {feature.badge && (
                  <div className={`inline-block ${feature.badge.color} text-dark-deep text-xs font-bold px-4 py-2 rounded-xl mb-6`}>
                    {feature.badge.text}
                  </div>
                )}

                {/* Icon */}
                <div className="w-12 h-12 flex items-center justify-center mb-6">
                  <i className={`${feature.icon} text-5xl text-neon-purple`}></i>
                </div>

                {/* Content */}
                <h3 className="text-3xl font-bold text-white mb-4">{feature.title}</h3>
                <p className="text-base text-gray-400 mb-8 leading-relaxed">{feature.description}</p>

                {/* Link */}
                <a href="#" className="inline-flex items-center gap-2 text-neon-purple font-semibold group-hover:gap-4 transition-all cursor-pointer">
                  자세히 보기
                  <i className="ri-arrow-right-line text-xl"></i>
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}